export async function connectorActionError(error: unknown): Promise<Error> {
  const response = (error as { context?: Response } | null)?.context;
  if (response && typeof response.clone === "function") {
    try {
      const body = await response.clone().json();
      if (typeof body?.error === "string") return new Error(body.error);
    } catch {
      // A lost/non-JSON response cannot establish whether the provider wrote.
    }
  }
  return new Error("outcome_unknown");
}

export function isUncertainConnectorWrite(error: unknown): boolean {
  return error instanceof Error && ["outcome_unknown", "idempotency_conflict", "duplicate_or_in_progress", "receipt_finalize_failed"].includes(error.message);
}
